'use client';
import HeadingBlock from "@/components/organisms/pb-sections/Heading";
import { HeadlineBlockProps } from "./types";
import { motion } from "framer-motion";
import { useRef } from "react";

export default function HeadlineBlock(data: HeadlineBlockProps) {
  const sectionRef = useRef(null);
  const floatAnimation = data?.hasShape ? {
    y: [0, -10, 0],
    transition: {
      y: {
        repeat: Infinity,
        duration: 3,
        ease: "easeInOut"
      }
    }
  } : {};

  return (
    <div ref={sectionRef} className="container mx-auto mt-32 md:mt-[44px] xl:mt-64 relative ">
      <div className={`xl:max-w-1/2 w-full md:pr-32`}>
        <HeadingBlock title={data.title} description={data.description} isRow={false} />
      </div>
      {data.hasShape && (
            <div className="absolute top-0 z-10 md:top-48 right-16 md:right-80 xl:right-128">
              <motion.svg 
                width="229" 
                height="46" 
                viewBox="0 0 229 46" 
                fill="none" 
                xmlns="http://www.w3.org/2000/svg"
                className="w-[124px] h-[25px] xl:w-[229px] xl:h-[46px]"
                initial={{ opacity: 0, x: 1 * 80 }}
                animate={{ 
                  opacity: 1, 
                  x: 0,
                  ...floatAnimation
                } as any}
                transition={{ 
                  x: { duration: 2, ease: "easeOut" },
                  opacity: { duration: 1.5 },
                  delay: 0.5
                }}
              >
                <path d="M229 0H0L89.9373 46L229 0Z" fill={"#0E8668"} />
              </motion.svg>
            </div>
          )}
    </div>
  );
}
